import { makeReduxDuck } from 'teedux';
import { TRootState } from 'src/app/store';
import { Moment } from 'moment';
import { IObject } from 'src/app/helpers/IconGenerator/IconGenerator';

const fuelTanksStorePath = `app/fuelTanks`;

interface IState {
    fuelTanks: IFuelTank[] | undefined;
    fuelTankEvents: IFuelTankDataItem[] | undefined;
    fuelTankOrdinaryEvents: IFuelTankDataItem[] | undefined;
}

interface IFuelTankDataItem {
    date: string;
    params: { [key: string]: any };
    state: { type: number };
    data: {
        vehicle?: string;
        employee?: string;
        fillLevel?: string;
        batteryLevel?: string;
    };
}

interface IFuelTank extends IObject {
    id: string;
    traits?: { binMonitor: boolean };
    updatedAt: Moment;
    data: {
        fillLevel: number;
        fuelLevel: number;
        capacity: number;
        logicType: number;
    };
}

export interface IFuelTanksEvents {
    id: number;
    values: IFuelTankDataItem[] | undefined;
}

const initialState: IState = {
    fuelTanks: undefined,
    fuelTankEvents: undefined,
    fuelTankOrdinaryEvents: undefined,
};

const duck = makeReduxDuck(fuelTanksStorePath, initialState);

export default duck.getReducer();

const getFuelTanksStore = (state: TRootState) => state.app.fuelTanks;

export const getFuelTanks = (state: TRootState) =>
    getFuelTanksStore(state).fuelTanks;
export const getFuelTankEvents = (state: TRootState) =>
    getFuelTanksStore(state).fuelTankEvents;
export const getFuelTankOrdinaryEvents = (state: TRootState) =>
    getFuelTanksStore(state).fuelTankOrdinaryEvents;
